import { BASE_URL } from "../stores/BASE_URL"
import { user } from "../stores/user"
import { navigate } from "svelte-routing"

export async function apiFetch(input, options = {}) {
  const base = new URL(BASE_URL, window.location.href)
  const url = new URL(input instanceof Request ? input.url : input, window.location.href)
  if (url.origin !== base.origin || !url.pathname.startsWith(base.pathname)) {
    throw new Error("Destino de API no permitido")
  }

  const headers = new Headers(options.headers || (input instanceof Request ? input.headers : undefined))
  let session = null
  try {
    session = JSON.parse(localStorage.getItem("admin-sbi-session"))
  } catch {
    user.setUser(null)
  }
  if (session && typeof session.session_key === "string") {
    headers.set("Authorization", `Bearer ${session.session_key}`)
  }

  const response = await fetch(input, { ...options, headers })
  if (response.status === 401) {
    user.setUser(null)
    navigate("/", { replace: true })
    throw new Error("La sesion ha expirado. Inicia sesion nuevamente.")
  }
  return response
}
